import React from "react";
import styled from "@emotion/styled";
import { Theme, useMediaQuery } from "@mui/material";
import { useMandatorContext } from "@bn/theming";
import { ARIVA_HEADER_HEIGHT_DESKTOP } from "@components/ArivaHeader/arivaHeaderConfig";

const StyledCenterScreen = styled("div", {
  shouldForwardProp: (prop) => prop !== "headerOffset",
})<{ headerOffset: number }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: calc(100vh - ${({ headerOffset }) => headerOffset}px);
`;

/**
 * Full-height centered container. On Ariva desktop the standalone header
 * occupies the top of the viewport, so subtract its (fixed) height to keep the
 * centered content within the visible area below it.
 */
export const CenterScreen = (props: React.HTMLAttributes<HTMLDivElement>) => {
  const { isAriva } = useMandatorContext();
  const isMobile = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );
  const headerOffset = isAriva && !isMobile ? ARIVA_HEADER_HEIGHT_DESKTOP : 0;

  return <StyledCenterScreen headerOffset={headerOffset} {...props} />;
};
